import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, forkJoin, switchMap } from 'rxjs';
import { ClaimItem } from '../model/claim-item';
import { ClaimDetailsItem } from '../model/claimdetails';
import { ClientItem } from '../model/client-item';
import { CoverageItem } from '../model/coverage-item';
import { QuestionSetItem } from '../model/questionset-item';
import { ExternalService } from './external.service';
import { MSSPService } from './mssp.service';
import { ClientPolicyDetail, RequestIntegrationItem } from '../model/client-policy-detail';
import { CoverageItemPolicy, PolicyDetailItem } from '../model/policy-detail-item';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  reqClientData!: ClientPolicyDetail;
  reqMsspData!: PolicyDetailItem
  policy!: string;
  idCliente!: string;
  apikey!: string;
  client!: string;
  deviceId!: string;
  certificate!: string;
  risk!: string;
  phone!: string
  startDate!: Date
  endDate!: Date
  productDate!: Date
  addressForm!: FormGroup
  personalForm!: FormGroup
  caseNumber!: string
  interactionNumber!: string
  userName!: string
  claimNumber!: string
  session!: string
  firstName!: string
  lastName!: string
  secondLastName!: string;
  isMultipleCertificate: boolean = false;

  questionSetItem!: QuestionSetItem

  dealerCode: string = '';
  companyCode: string = 'ASM';

  constructor(
    private externalService: ExternalService,
    private msspService: MSSPService,) { }

  getlistProducts(policy: string, idClient: string, apikey: string, client: string, certificate: string, serialnumber: string, dealerCode: string): Observable<any> {
    const reqMssp = this.msspService.getPolicy(policy, idClient, certificate, this.isMultipleCertificate, this.dealerCode, 'object')
      .pipe(
        switchMap((response) => this.msspService.getDetails(idClient, response.data.CertificateNumber, response.data.DealerCode, serialnumber, policy))
      )
    console.log("getProducts common service")
    return forkJoin({
      reqClient: this.externalService.getProducts(apikey, policy, client, idClient, certificate, dealerCode),
      reqMssp: reqMssp
    })
  }

  getPolicyDetails(policy: string, idClient: string, certificate: string, serialnumber: string): Observable<any> {
    console.log("ccl", policy, idClient, certificate)
    const reqMssp = this.msspService.getPolicy(policy, idClient, certificate, this.isMultipleCertificate, this.dealerCode, 'object')
      .pipe(
        switchMap((response) => this.msspService.getDetails(idClient, response.data.CertificateNumber, response.data.DealerCode, serialnumber, policy))
      )

    return forkJoin({
      reqMssp: reqMssp
    })

  }

  getBuildClaim(claimItem: ClaimItem): Observable<any> {
    const reqDevice = this.externalService.getIpAddress()
      .pipe(
        switchMap((response) => this.msspService.beginClaim(claimItem, response.ip)))

    return forkJoin({
      reqDevice: reqDevice
    })
  }

  getClaimDetails(policy: string, idClient: string, ClaimDetailsItem: ClaimDetailsItem): Observable<any> {
    const reqMssp = this.msspService.getClaimDetails(ClaimDetailsItem)

    return forkJoin({
      reqDetailClaim: reqMssp,

    })
  }

  typeValidation(coverage: CoverageItemPolicy): boolean {
    if (coverage.CoverageTypeCode == "Power Surge")
      return true
    return false
  }

  validateNo(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode <= 47 || charCode > 57)) {
      return false
    }
    return true
  }

  validateNoSpace(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode >= 33 && (charCode <= 47 || charCode > 57)) {
      return false
    }
    return true
  }

  validateCa(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if ((charCode >= 33 && charCode < 65 || charCode > 90) &&
      (charCode < 96 || charCode > 122) &&
      (charCode < 209 || charCode > 209) &&
      (charCode < 241 || charCode > 241) &&
      (charCode < 225 || charCode > 225) &&
      (charCode < 233 || charCode > 233) &&
      (charCode < 237 || charCode > 237) &&
      (charCode < 243 || charCode > 243) &&
      (charCode < 250 || charCode > 250)
    ) {
      return false
    }
    return true
  }

  validateSpecialChar(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (
      (charCode < 45 || charCode > 58) &&
      (charCode < 64 || charCode > 90) &&
      (charCode < 95 || charCode > 122) ||
      (charCode == 47)
    ) {
      return false
    }
    return true
  }

  validateSpecialCharDescription(e: any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (
      !this.validateNoSpace(e) && !this.validateCa(e)
    ) {
      return false
    }
    return true
  }

  capitalLetter(e: Array<RequestIntegrationItem>): Array<RequestIntegrationItem> {
    return e?.map((res) => {
      res.SubArea = res.SubArea[0].toUpperCase() + res.SubArea.substr(1).toLowerCase()
      res.ShowButton = true
      res.R3Fechaterminollamada = (res.R3Fechaterminollamada === '' || res.R3Fechaterminollamada === null || typeof res.R3Fechaterminollamada === 'undefined') ? this.getAddedYearsDate(res.R3Fechaservicio) : res.R3Fechaterminollamada;
      res.R3Fechaasignacion = (res.R3Fechaasignacion === '' || res.R3Fechaasignacion === null || typeof res.R3Fechaasignacion === 'undefined') ? this.getAddedYearsDate(res.R3Fechaterminollamada) : res.R3Fechaasignacion;
      res.EstadoGarantia = (res.EstadoGarantia === '' || res.EstadoGarantia === null || typeof res.EstadoGarantia === 'undefined' ) ? this.getStatusWarranty(res.R3Fechaterminollamada, res.R3Fechaasignacion) : res.EstadoGarantia;
      return res;
    })
  }

  getAddedYearsDate(date: string): string {
    let resultDate: string = '';
    let splittedString = date.split('/');
    const newDate: Date = new Date(Number(splittedString[2]) + 1, Number(splittedString[1]) - 1, Number(splittedString[0]));
    resultDate = `${ (newDate.getDate() < 10) ? '0' + newDate.getDate() : newDate.getDate() }/${((newDate.getMonth() + 1) < 10) ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)}/${newDate.getFullYear()}`;
    return resultDate;
  }

  getStatusWarranty(dateMaker: string, datePÏF: string): string {
    let status: string = '';
    const today: Date = new Date();
    const sDateMaker: string[] = dateMaker.split('/');
    const sDatePIF: string[] = datePÏF.split('/');
    const convertedDateMaker: Date = new Date(Number(sDateMaker[2]), Number(sDateMaker[1]) - 1, Number(sDateMaker[0]));
    const convertedDatePIF: Date = new Date(Number(sDatePIF[2]), Number(sDatePIF[1]) - 1, Number(sDatePIF[0]));

    if (convertedDateMaker.getTime() > today.getTime()) {
      status = "Garantía Fabricante";
    } else if (today.getTime() > convertedDateMaker.getTime() && today.getTime() < convertedDatePIF.getTime()) {
      status = "Garantía +G PIF";
    } else if (today.getTime() > convertedDatePIF.getTime()) {
      status = "Fin de vigencia"
    }

    return status;
  }

}
